import { Divider, Tab, Tabs } from '@mui/material';
import React from 'react';
import { Control, UseFormSetValue } from 'react-hook-form';
import Icons from '../../../components/icons';
import { StudentDetailProps } from '../types/studentDetailType';
import { familyTabTypes } from '../types';
import { SnackbarSeverityType } from '../../../enums';
import { FamilyTabOptions } from '../config/constant';
import FamilyTabContent from './FamilyTabContent';
import pallet from '../../../layouts/pallet';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const FamilyInformationForm = ({
  control,
  setValue,
  activeTab,
  setActiveTab,
  showToast
}: {
  control: Control<StudentDetailProps, any, StudentDetailProps>;
  setValue: UseFormSetValue<StudentDetailProps>;
  activeTab: familyTabTypes;
  setActiveTab: React.Dispatch<React.SetStateAction<familyTabTypes>>;
  showToast: (message: string, severity: SnackbarSeverityType) => void;
}) => {
  const loggedInUser = useSelector((state: RootState) => state.profile);
  const visibleTabs = FamilyTabOptions.filter(
    (tab) => !(tab.id === 'guardianDetails' && loggedInUser?.user?.school === 'BPIS')
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    const tabId = visibleTabs[newValue]?.id;
    if (tabId) {
      setActiveTab(tabId);
    }
  };

  return (
    <>
      <Tabs
        value={visibleTabs.findIndex((tab) => tab.id === activeTab)}
        onChange={handleChange}
        aria-label='icon position tabs example'
      >
        {visibleTabs.map((tab) => {
          const IconComponent =
            activeTab === tab.id ? tab.selectedIcon : tab.unselectedIcon;
          const Icon = IconComponent || Icons.UserFilled;
          return (
            <Tab
              key={tab.id}
              icon={
                <Icon
                  style={{
                    height: '18px',
                    width: '18px',
                    marginRight: 8
                  }}
                />
              }
              sx={{
                fontWeight: '500',
                color: pallet.formLabelText,
                textTransform: 'capitalize',
                padding: '8px 20px',
                fontSize: '15px'
              }}
              iconPosition='start'
              label={tab.label}
            />
          );
        })}
      </Tabs>
      <Divider sx={{ mb: 3, maxWidth: '445px' }} />
      <FamilyTabContent
        activeTab={activeTab}
        control={control}
        setValue={setValue}
        showToast={showToast}
      />
    </>
  );
};

export default FamilyInformationForm;
